import { render, staticRenderFns } from "./ContactSupport.vue?vue&type=template&id=6a234ce5&scoped=true"
import script from "./ContactSupport.vue?vue&type=script&lang=js"
export * from "./ContactSupport.vue?vue&type=script&lang=js"
import style0 from "./ContactSupport.vue?vue&type=style&index=0&id=6a234ce5&prod&lang=stylus&scoped=true"
import style1 from "./ContactSupport.vue?vue&type=style&index=1&id=6a234ce5&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a234ce5",
  null
  
)

export default component.exports